import { render, staticRenderFns } from "./newDirectPkg.vue?vue&type=template&id=814a1308&scoped=true&"
import script from "./newDirectPkg.vue?vue&type=script&lang=js&"
export * from "./newDirectPkg.vue?vue&type=script&lang=js&"
import style0 from "./newDirectPkg.vue?vue&type=style&index=0&id=814a1308&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814a1308",
  null
  
)

export default component.exports